import { useState } from 'react'
import { Monitor } from 'lucide-react'

import { useDisplayUsers } from '@/hooks/use-user-query'
import { m } from '@/lib/paraglide/messages'

const STORAGE_KEY = 'pos_display_user_id'
export const DISPLAY_CHANGED_EVENT = 'pos-display-change'

export function getDisplayUserId(): string | undefined {
    return localStorage.getItem(STORAGE_KEY) || undefined
}

export function PosDisplayPicker() {
    const [selectedId, setSelectedId] = useState(
        () => localStorage.getItem(STORAGE_KEY) ?? '',
    )
    const { data } = useDisplayUsers()
    const users = data ?? []

    function handleSelect(userId: string) {
        setSelectedId(userId)
        if (userId) {
            localStorage.setItem(STORAGE_KEY, userId)
        } else {
            localStorage.removeItem(STORAGE_KEY)
        }
        window.dispatchEvent(new Event(DISPLAY_CHANGED_EVENT))
    }

    return (
        <div className="flex items-center gap-1">
            <Monitor className="size-3.5 text-primary-foreground/60" />
            <select
                value={selectedId}
                onChange={(e) => handleSelect(e.target.value)}
                className="bg-primary-foreground/10 text-primary-foreground text-xs rounded px-1.5 py-1 border-none outline-none cursor-pointer"
            >
                <option value="" className="bg-background text-foreground">
                    {m.pos_no_display()}
                </option>
                {users.map((u) => (
                    <option
                        key={u.id}
                        value={u.id}
                        className="bg-background text-foreground"
                    >
                        {u.full_name || u.username}
                    </option>
                ))}
            </select>
        </div>
    )
}
